// src/Components/Form2/RadioGroup/RadioGroup.js
import React from "react";
import styles from "./RadioGroup.module.css";

const RadioGroup = ({ children, onChange }) => {
  const { label, required, options = [], name, value } = children || {};

  const handleChange = (e) => {
    onChange?.({ target: { name, value: e.target.value } });
  };

  return (
    <div className={styles.container}>
      {label && (
        <label className={styles.label}>
          {label} {required && "*"}
        </label>
      )}
      <div className={styles.options}>
        {options.map((option, index) => (
          <label key={index} className={styles.radioLabel}>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={String(value) === String(option.value)} 
              onChange={handleChange}
              className={styles.radioInput}
              required={required}
            />
            <span className={styles.radioButton}></span>
            {option.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
